<template>
    <div class="authors-select">
        <MultiSelect
            v-model="selectedAuthors"
            :options="combinedAuthors"
            :form-value-text="getFullName"
            :with-filter="!!customer"
            width="100%"
            emit-prop="id"
            :paginate="pagination > 0"
            :paginate-amount="pagination"
            :empty-text="$t(!customer ? 'crm.orders.selectCustomer' : 'crm.authors.noData')"
            class="select--outlined"
            @search="onSearch"
        >
            <template #default="{ item }">
                {{ getFullName(item) }}
            </template>
            <template #list-prepend="{ close }">
                <li v-if="!!customer" class="authors-select__manager-trigger">
                    <AuthorsEdit @opened="close" @saved="onSaved" />
                </li>
            </template>
        </MultiSelect>
    </div>
</template>

<script>
import AuthorsEdit from '../AuthorsEdit/AuthorsEdit';
import { fetchCustomersAuthors } from '../../../customers/api/customers';
import { MultiSelect } from '@speechki-frontend/shared/ui/forms';
import { mapGetters } from 'vuex';

const noop = () => {};
const empty = () => ({});

export default {
    name: 'AuthorsSelect',
    components: {
        AuthorsEdit,
        MultiSelect,
    },
    inject: {
        context: {
            default: empty,
        },
        registerControl: {
            default: () => noop,
        },
    },
    provide() {
        return {
            context: this.context,
            registerControl: this.registerControl,
        };
    },
    props: {
        modelValue: {
            type: Array,
            default: () => [],
        },
        customer: {
            type: [String, Number],
            default: null,
        },
        pagination: {
            type: Number,
            default: 10,
        },
        order: {
            type: String,
            default: 'first_name',
        },
    },
    emits: ['update:modelValue'],
    data() {
        return {
            selectedAuthors: [],
            createdAuthors: [],
            customerAuthors: [],
        };
    },
    computed: {
        ...mapGetters('workspaces', ['isInnerWorkspace', 'workspaceCustomerId']),

        combinedAuthors() {
            const stringCollator = new Intl.Collator(this.$i18n.locale, {
                sensitivity: 'accent',
                usage: 'sort',
            });
            return [...this.createdAuthors, ...this.customerAuthors].sort((a, b) =>
                stringCollator.compare(a[this.order], b[this.order])
            );
        },
    },
    watch: {
        customer: {
            immediate: true,
            handler(customer) {
                if (!customer) return;
                this.fetchCustomersAuthors();
            },
        },
        selectedAuthors: {
            deep: true,
            handler() {
                this.$emit(
                    'update:modelValue',
                    this.selectedAuthors.map((id) => {
                        const { last_name, first_name, patronymic } = this.combinedAuthors.find(
                            (author) => author.id === id
                        );
                        return { last_name, first_name, patronymic };
                    })
                );
            },
        },
        customerAuthors: {
            deep: true,
            handler(value, oldValue = []) {
                if (!oldValue.length) return;
                const oldList = oldValue.map(({ id }) => id);
                this.selectedAuthors = this.selectedAuthors.filter((id) => !oldList.includes(id));
            },
        },
    },
    methods: {
        async fetchCustomersAuthors() {
            const { results } = await fetchCustomersAuthors(this.customer);
            this.customerAuthors = results;
        },
        getFullName({ full_name = null, first_name, last_name }) {
            return full_name || [first_name, last_name].join(' ');
        },
        reset() {
            this.selectedAuthors = [];
        },
        onSaved(event) {
            this.createdAuthors.push(event);
            this.selectedAuthors.push(event.id);
        },
        onSearch(event) {
            console.log('onSearch', event);
        },
    },
};
</script>

<style lang="scss" src="./AuthorsSelect.scss"></style>
